// Generated file: Do not edit 
// generated from @taqueria-protocol-types
    
import { TaqError, toFutureParseErr, toFutureParseUnknownErr, toParseErr, toParseUnknownErr } from '@taqueria/protocol/TaqError';
import { FutureInstance, resolve, reject } from 'fluture';
import { ZodError } from 'zod';
import { SandboxAccounts } from '@taqueria/protocol/types';
import { SandboxAccounts as SandboxAccountsStrict } from '@taqueria/protocol/out/types-strict';
import { sandboxAccountsSchema } from '@taqueria/protocol/out/types-zod';

export type { SandboxAccountsStrict as SandboxAccounts };

export const from = (input: unknown): SandboxAccountsStrict => {
	try {
		return sandboxAccountsSchema.parse(input) as SandboxAccountsStrict;
	}
	catch (previous: unknown) {
		if (previous instanceof ZodError) {
			const msgs: string[] = previous.errors.reduce(
				(retval, issue) => {
					const path = issue.path.join(' → ');
					const msg = path + ': ' + issue.message;
					return [...retval, msg];
				},
				["SandboxAccounts is invalid:"],
			);
			const validationErr = msgs.join('\n') + '\n';
			throw toParseErr(previous, validationErr);
		}
		throw toParseUnknownErr(previous, "There was a problem trying to parse a SandboxAccounts.")
	}
    
};

export const create = (input: SandboxAccounts): SandboxAccountsStrict => from(input);

export const of = (input: unknown): FutureInstance<TaqError, SandboxAccountsStrict> => {
	try {
		return resolve(from(input))
	}
	catch (err){
		return reject(err) as FutureInstance<TaqError, never>
	}
};

export const make = (input: Omit<SandboxAccountsStrict, '__type'>): FutureInstance<TaqError, SandboxAccountsStrict> => of(input);

// TEMP: for interoperation with old protocol types during transition
export const schemas = {
	rawSchema: sandboxAccountsSchema,
	schema: sandboxAccountsSchema.transform(val => val as SandboxAccountsStrict),
};
export const rawSchema = schemas.rawSchema;
export const internalSchema = sandboxAccountsSchema;

export type t = SandboxAccountsStrict;
        